export default "__VITE_ASSET__e70a908b__"